import ColorField from "../../../components/Form/ColorField";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_BACKGROUND_PADDING,
  TEMPLATES_BACKGROUND_RADIUS,
  TEMPLATES_BACKGROUND_SEPARATION,
  TEMPLATES_PAINT_SETTINGS,
} from "../../../i18n/keysTranslations";
import PaintMetricSettings from "./PaintMetricSettings";

const optionalRules = { required: false };
const PADDING_SLIDER_MAX = 48;
const RADIUS_SLIDER_MAX = 80;

const TextBackgroundFields = ({
  control,
  errors,
  disabled = false,
  onChangeField,
}) => {
  const { t } = useTranslationApp();
  return (
    <ColorField
      control={control}
      errors={errors}
      name="backgroundColor"
      label={t(TEMPLATES_BACKGROUND_PADDING)}
      fullWidth
      disabled={disabled}
      rules={optionalRules}
      actionsChange={(value) =>
        onChangeField({ key: "backgroundColor", value })
      }
      trailing={
        <PaintMetricSettings
          control={control}
          errors={errors}
          disabled={disabled}
          ariaLabel={t(TEMPLATES_PAINT_SETTINGS)}
          fields={[
            {
              name: "backgroundPadding",
              label: t(TEMPLATES_BACKGROUND_SEPARATION),
              sliderMax: PADDING_SLIDER_MAX,
              onChangeField,
            },
            {
              name: "backgroundRadius",
              label: t(TEMPLATES_BACKGROUND_RADIUS),
              sliderMax: RADIUS_SLIDER_MAX,
              onChangeField,
            },
          ]}
        />
      }
    />
  );
};

export default TextBackgroundFields;
